<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import uiStore from '../utils/UIStore';
import { getAktuelleLegislatur, getYesterday, reformatDate } from '../utils/dateUtils.js';

export let source = null;
export let visibleDBSourceDatapicker = '';
export let sources = [];

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

let startDate = '2016-01-01';

function setAktuelleLegislatur(source) {
  /*
        Set Daterange filter of source to current Legislaturperiode (2021-today)
        */
  if (source.meta?.date_range) {
    // set date range
    source.meta.date_range = getAktuelleLegislatur();

    // update sources to trigger re-rendering
    sources = [...sources];
  }
}

function setGesamtenZeitraum(source) {
  /*
        Set Daterange filter of source to the maximum (2016-today)
        */
  if (source.meta?.date_range) {
    // set date range
    let end_date = getYesterday();
    source.meta.date_range = [startDate, end_date];

    // update sources to trigger re-rendering
    sources = [...sources];
  }
}

export function validateDates(source) {
  /*
        Check if startdate and enddate have a valid date format and end is after startdate,
        if not set to default (start=2016, end=today)
        */
  let start = reformatDate(startDate);
  let end = getYesterday();

  if (source.meta.date_range.length > 0 && isDateValid(source.meta.date_range[0])) {
    start = source.meta.date_range[0]; //.toISOString().split('T')[0];
  }
  if (source.meta.date_range.length > 1 && isDateValid(source.meta.date_range[1])) {
    end = source.meta.date_range[1]; //.toISOString().split('T')[0];
  }
  //set start to enddate if end is after startate
  if (end < start) {
    start = end;
  }
  source.meta.date_range[0] = start;
  source.meta.date_range[1] = end;

  // update sources to trigger re-rendering
  sources = [...sources];

  return source;
}

function isDateValid(dateStr) {
  return !Number.isNaN(new Date(dateStr));
}
</script>

<div
    id={source.id}
    class="datepicker-box"
    style="width:305px; display: {visibleDBSourceDatapicker === source.id
        ? 'block'
        : 'none'}"
>
    <div style="width:100%;margin-bottom:8px;">
        <span style="font-size: 1rem; font-weight: 600;text-align: left;">
            {uiTexts.dateFilter.title}</span
        >
    </div>
    <div class="date-container">
        <input
            type="date"
            bind:value={source.meta.date_range[0]}
            min={startDate}
            max={source.meta.date_range[1]}
            required
        />

        <input
            type="date"
            bind:value={source.meta.date_range[1]}
            min={source.meta.date_range[0]}
            max={getYesterday()}
            required
        />
    </div>

    <div class="date-buttons">
        <button
            class="no-btn-style"
            style="width:100%; text-align: left;margin-bottom:8px;flex:1;border:2px solid #000"
            aria-label="{uiTexts.dateFilter.ariaSelectCurrentLegislature}"
            title="{uiTexts.dateFilter.ariaSelectCurrentLegislature}"
            on:click={() => setAktuelleLegislatur(source)}
        >
            {uiTexts.dateFilter.ariaSelectCurrentLegislature}
        </button>
        <button
            class="no-btn-style"
            style="width:100%; text-align: left;margin-bottom:8px;flex:1;border:2px solid #000"
            aria-label="{uiTexts.dateFilter.ariaSelectAllTime}"
            title="{uiTexts.dateFilter.ariaSelectAllTime}"
            on:click={() => setGesamtenZeitraum(source)}
        >
            {uiTexts.dateFilter.btnAllTime}
        </button>

        <button
            aria-label="{uiTexts.dateFilter.ariaCloseCalendar}"
            title="{uiTexts.dateFilter.ariaCloseCalendar}"
            on:click={() => {
                validateDates(source);
                visibleDBSourceDatapicker = "";
            }}
            style="flex:1"
        >
            {uiTexts.dateFilter.btnClose}
        </button>
    </div>
</div>

<style>
    input {
        margin: 0px;
    }

    .date-container {
        display: flex;
        margin-bottom: 8px;
        justify-content: space-between;
    }
    .date-buttons {
        display: flex;
        flex-direction: column;
        align-items: end;
    }
    input[type="date"]::-webkit-clear-button {
        display: none;
    }

    .datepicker-box {
        position: absolute;
        left: 0;
        top: 40px;
        background: #fff;
        padding: 8px;
        box-shadow: 0 3px 9px rgba(0, 0, 0, 0.3);
        z-index: 1;
    }
    .datepicker-box > div {
        display: flex;
    }

    .datepicker-box div input {
        border: 1px solid #000;
    }
    .datepicker-box div input:first-child {
        margin-right: 12px;
    }
</style>
